/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * editor
 * http://docs.ckeditor.com/#!/guide/dev_jquery
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    var ELEM = '[data-fd="editor"]';
    var CK_HIGHLIGHT_BUTTON_NAME = 'BGColor';
    var CK_IMAGE_BUTTON_NAME = 'Image';

    CKEDITOR.tools.array.zip = function (array1, array2) {
        return CKEDITOR.tools.array.map(array1, function (value, index) {
            return [value, array2[index]];
        });
    }

    $.widget("custom.editor", {
        options: {
            limited: false,
            strategyoption: false,
            removeimageicon: false,
            allowimage: true,
            useparent: true,
            parentid: -1,
            height: 150,
            initial: '',
            tag: 300,
            customConfig: false,
            removePlugins: 'sourcearea,about,iframe',
            resize_enabled: false,
            removeButtons: 'Image,Undo,Redo,ShowBlocks,SpecialChar,Anchor,Strike,Subscript,Superscript,Save,Paste,PasteText,Cut,Copy,SelectAll,Outdent,Indent,JustifyBlock,JustifyRight,JustifyCenter,JustifyLeft,CopyFormatting,Language,Print,Maximize',
            forcePasteAsPlainText: true,
            removeDialogTabs: 'link:advanced;link:target',
            enterMode: CKEDITOR.ENTER_BR,
            shiftEnterMode: CKEDITOR.ENTER_P,
            extraPlugins: 'autogrow',
            autogrow_onstartup: false
        },
        extendedOptions: {
            allowhighlight: true,
            allowedContent: true,
            toolbarGroups: [
                { name: 'clipboard', groups: ['clipboard', 'undo'] },
                { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
                { name: 'forms', groups: ['forms'] },
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'colors', groups: ['colors'] },
                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'links', groups: ['links'] },
                { name: 'insert', groups: ['insert'] },
                { name: 'styles', groups: ['styles'] },
                { name: 'tools', groups: ['tools'] },
                { name: 'document', groups: ['mode', 'document', 'doctools'] },
                { name: 'others', groups: ['others'] },
                { name: 'about', groups: ['about'] }
            ],
            removeButtons: 'ShowBlocks,SpecialChar,Anchor,Strike,Subscript,Superscript,Save,Paste,PasteText,Cut,Copy,SelectAll,Outdent,Indent,JustifyBlock,JustifyRight,JustifyCenter,JustifyLeft,CopyFormatting,Language,Print,Maximize',
            imageuploaded: null,
            extraPlugins: 'colorbutton,colordialog,youtube,font,richcombo,listblock,table,tableresize,autogrow',
            youtube_responsive: true,
            youtube_related: false,
            youtube_privacy: true,
            youtube_disabled_fields: ['chkAutoplay'],
            autogrow_onstartup: false
        },
        strategyOptions: {
            toolbarGroups: [
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'colors', groups: ['colors'] },
                { name: 'paragraph', groups: ['indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'links', groups: ['links'] },
                { name: 'styles', groups: ['styles'] },
            ],
            removeButtons: 'Image,Undo,Redo,ShowBlocks,SpecialChar,Anchor,Strike,Subscript,Superscript,Save,Paste,PasteText,Cut,Copy,SelectAll,Outdent,Indent,JustifyBlock,JustifyRight,JustifyCenter,JustifyLeft,CopyFormatting,Language,Print,Maximize',
            extraPlugins: 'colorbutton,font,autogrow',
        },
        imageOptions: {
            extraPlugins: 'colorbutton,colordialog,youtube,image2,uploadimage,filebrowser,font,richcombo,listblock,table,tableresize,autogrow',
            uploadUrl: '/Media/HandleImageUpload',
            filebrowserImageUploadUrl: '/Media/HandleImageUpload',
        },
        _create: function () {
            this.options.language = getUserLaguageOrDefault();
            $.extend(this.options, this.element.data());
            this.options.autoGrow_onStartup = this.options.autogrow_onstartup;
            delete this.options['custom-editor'];

            if (!this.options.limited) {
                $.extend(this.options, this.extendedOptions);
            }

            if (this.options.strategyoption) {
                $.extend(this.options, this.strategyOptions);
            }

            me.setControlItemOptions(this.element, this.options);

            if (!this.options.allowhighlight) {
                this.options.removeButtons += ',' + CK_HIGHLIGHT_BUTTON_NAME;
            }
            if (this.options.removeimageicon) {
                this.options.removeButtons += ',' + CK_IMAGE_BUTTON_NAME;
            }
            if (this.options.allowimage && !this.options.limited) {
                $.extend(this.options, this.imageOptions);
            }

            this.element.ckeditor(this.options);
            this.element.closest('.modal').removeAttr('tabindex');

            this.element.editor.on('focus', this._handleFocus);
            this.element.editor.on('change', this._handleChange);
            if (this.options.allowimage && !this.options.limited) {
                this.element.editor.on('fileUploadResponse', this._fileUploadResponse);
            }
            var self = this;
            if (this.element.is('.hidden')) {
                this.element.editor.on("instanceReady", function (event) {
                    self.element.next().addClass('hidden');
                });
            }

            this.element.addClass("editor");
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.element.data(options);
            this.refresh();
        },
        refresh: function () {
        },
        _destroy: function () {
        },

        _handleFocus: function (event) {
            var self = $(event.editor.element.$).data('customEditor');
            self.options.initial = self.element.val();
        },
        _handleChange: function (event) {
            var self = $(event.editor.element.$).data('customEditor');

            clearTimeout(self._changeTimer);
            self._changeTimer = setTimeout(function () {
                self._handleChangeDebounce()
            }, 750);
        },
        _handleChangeDebounce: function () {
            var val = this.element.val();
            var div = document.createElement('div');
            $(div).html(val).find('a').attr('target', '_blank');
            val = $(div).html();
            $(div).remove();

            if (this.options.initial != val) {
                this.options.value = val;
                this._setCallback();
                this.options.initial = this.options.value;
            }
        },

        _fileUploadResponse: function (event) {
            var self = $(event.editor.element.$).data('customEditor');
            // Prevent the default response handler.
            event.stop();

            var data = event.data,
                xhr = data.fileLoader.xhr,
                response = xhr.responseText;

            if (!response) {
                evt.cancel();
            } else {
                data.url = xhr.getResponseHeader('MediaURL');
                data.upload = 1;
                data.fileName = data.url.substr(data.url.lastIndexOf("/") + 1);
            }
            if (self.options.imageuploaded) {
                eval(self.options.imageuploaded + "(" + response + ")")
            }
        },

        _setCallback: function () {
            me.setCallBackFromData(this.element, {
                e: this.element,
                value: this.options.value,
                initial: this.options.initial,
                length: this.options.value.length,
                tag: this.options.tag,
                parentid: this.options.parentid
            });
        }
    });


    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    function getUserLaguageOrDefault() {
        var supportedLangs = ['en', 'es', 'es-mx', 'hu', 'sk', 'zh', 'zh-cn'];
        var userLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
        var found = supportedLangs.some(function (elem) { return elem == userLang; });
        if (!found && userLang.length > 2) {
            userLang = userLang.split('-')[0];
            found = supportedLangs.some(function (elem) { return elem == userLang; });
        }
        return found ? userLang : "en";
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  get editor options
    child.setEditor = function (container) {
        var list = '';
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.is(ELEM) ? container : container.find(ELEM);
        } else {
            list = $(ELEM);
        }
        $(list).editor();
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));